/*
 * Seed IM - Service to manage configuration for the app stored in the repo.
 */
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { delay, switchMap,  tap } from 'rxjs/operators';
//import { HttpClient } from '@angular/common/http';
import { ContentApiService } from '@alfresco/aca-shared';
import { NodeEntry } from '@alfresco/js-api';
//import { AlfrescoApiService } from '@alfresco/adf-core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DocuServeConfigurationService {

  appConfig: any;

  constructor(

    private contentApi: ContentApiService,
    private http: HttpClient) {
  }

  getAppConfig(): Observable<any>{
    if(this.appConfig){
      //console.log("already set state", this.appConfig);
      return of(this.appConfig);
    }else{
      return this.getAppConfigFile().pipe(tap(data => this.appConfig = data));
    }
  }

  getAppConfigFile(): Observable<any> {
    //console.log("getAppConfigFile entered");
    let observable$ = this.getAppConfigFileNode();
    return observable$.pipe(
      delay(1000),
      tap(configFile => console.log("getAppConfigFile", configFile)),
      switchMap((configFile: NodeEntry) => {
        // console.log(
        //   'configFile found so getting Config File Content',
        //   configFile
        // );
         return this.getAppConfigFileContent(configFile.entry.id);
      })
    );
  }
  getAppConfigFileNode(): Observable<NodeEntry> {
    //console.log("getAppConfigFileNode entered");
    return this.contentApi.getNode('-root-', {
      includeSource: true,
      include: ['path', 'properties', 'allowableOperations'],
      relativePath:
        '/Data Dictionary/jobdocuments/Configs/AppConfig.json'
    }).pipe(tap(result => console.log("getAppConfigFileNode", result)));


  }

  loadConfig(): Observable<boolean>{
    return of(true);
  }


  getAppConfigFileContentUrl(nodeId: string): string {
    //console.log('getAppConfigFileContentUrl method', nodeId);
    return this.contentApi.getContentUrl(nodeId);
  }
  getAppConfigFileContent(nodeId: string){
    //console.log("this.getAppConfigFileContentUrl(nodeId)", nodeId);

    return this.http.get(this.getAppConfigFileContentUrl(nodeId));
  }

}
